import React, { Suspense } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { Spin } from "antd";
import TemplateSelection from "./pages/TemplateSelection";
import useUserDetails from "./utils/useUserDetails";
import CRMPage from "./pages/CRMPage";
import AttendanceManagement from "./pages/AttendanceManagement";
import MyLeaves from "./pages/MyLeaves";
import MyCorrection from "./pages/MyCorrection";
import LeavesTable from "./pages/LeavesTable";
import TeamCorrectionTable from "./pages/TeamCorrectionTable";
import AttendanceSummaryTable from "./pages/AttendanceSummaryTable";
import AttendanceTable from "./pages/AttendanceTable";
import UserPage from "./pages/UserPage";
import DmsPage from "./pages/DmsPage";
import TeamLeavesTable from "./pages/TeamLeavesTable";
import TeamCorrectionApprovalTable from "./pages/TeamCorrectionApprovalTable";


export default function BasePage(props) {
  const userRole = localStorage.getItem("userRole");
  let userDetails = {};
  if (userRole !== "company") {
    userDetails = JSON.parse(localStorage.getItem("userDetails"));
  }
  const userData = useUserDetails();
  return (
    <Suspense
      fallback={
        <Spin
          size="large"
          style={{ display: "block", margin: "auto", marginTop: "20%" }}
        />
      }
    >
      <Switch>
        {/* Redirect from root URL to appropriate dashboard */}
        {(userRole == "company" ||
          userData?.permissions?.includes("add_technology_niche")) &&
          props.CompanyRoutesConfig.length > 0 &&
          props.CompanyRoutesConfig.map((route, index) => (
            <Route path={route.path} component={route.component} key={index} />
          ))}
        {userRole !== "company" &&
          props?.CompanyRoutesConfig?.map((route, index) => {
            const hasPermission = userDetails?.roleId?.permissions?.some(
              (permission) =>
                route.permission && route.permission.includes(permission),
            );
            return hasPermission ? (
              <Route
                path={route.path}
                component={route.component}
                key={index}
              />
            ) : null;
          })}
        <Route path="/company/CRM" component={CRMPage} />
        <Route path="/company/attendance" component={AttendanceManagement} />
        <Route path="/company/users" component={UserPage} />
        <Route path="/company/my-leave" component={MyLeaves} />
        <Route path="/company/leave-management" component={LeavesTable} />
        <Route path="/company/my-correction" component={MyCorrection} />
        <Route
          path="/company/correction-management"
          component={TeamCorrectionTable}
        />
        <Route path="/company/team-leaves" component={TeamLeavesTable} />
        <Route path="/company/team-corrections" component={TeamCorrectionApprovalTable} />
        <Route
          path="/company/attendance-summary"
          component={AttendanceSummaryTable}
        />
        <Route path="/company/attendance-sheet" component={AttendanceTable} />
        <Route path="/company/template1" component={TemplateSelection} />
        <Route path="/company/dms" component={DmsPage} />


        {props.userRole === "company" ? (
          <Redirect from="/" to="/company/dashboard" />
        ) : (
          <Redirect from="/" to="/company/requirements" />
        )}
        <Redirect to="/error" />
      </Switch>
    </Suspense>
  );
}
